<template>
  <div id="form-meal">
    <h2>
      <span v-if="editingMode === 'edit'">Editar</span>
      <span v-if="editingMode === 'create'">Nova</span> Refeiçao
    </h2>
    <br />
    <b-container>
      <b-row>
        <b-tabs class="mt-4 w-100">
          <b-tab title="Português">
            <translations-meal v-bind.sync="editingCache" :disabledInputs="disabledInputs" />
          </b-tab>
          <b-tab title="Inglês">
            <translations-meal v-bind.sync="editingCache" :disabledInputs="disabledInputs" />
          </b-tab>
          <b-tab title="Francês">
            <translations-meal v-bind.sync="editingCache" :disabledInputs="disabledInputs" />
          </b-tab>
          <b-tab title="Espanhol">
            <translations-meal v-bind.sync="editingCache" :disabledInputs="disabledInputs" />
          </b-tab>
        </b-tabs>
        <b-col sm="12" v-if="editingMode === 'create'">
          <b-input-group
            prepend="Escolha o Menu"
            size="sm"
            class="mt-4"
            style="margin-bottom: 20px;"
          >
            <b-form-select v-model="selected" :options="menuNames" v-validate.initial="'required'"></b-form-select>
          </b-input-group>
        </b-col>
      </b-row>
    </b-container>
    <br />
    <div v-if="editingMode !== 'view'">
      <b-button
        variant="primary"
        @click="editingMode === 'edit' ? updateMeal(editingCache.id) : createMeal()"
        :disabled="errors.count() > 0"
      >Submeter</b-button>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import { mapMutations, mapActions, mapGetters } from "vuex";
import translationsMeal from "./translationsMeal";

export default {
  name: "formMeal",
  props: {
    editingMode: { type: String, required: true },
    meal: { type: Object }
  },
  components: {
    "translations-meal": translationsMeal
  },
  data() {
    return {
      selected: null,
      editingCache: {
        name: "",
        mealCategory: ""
      }
    };
  },
  computed: {
    ...mapGetters(["menuNames", "menuIdFromName"]),
    disabledInputs() {
      return this.editingMode === "view";
    }
  },
  mounted() {
    if (this.editingMode !== "create") {
      this.editingCache = Object.assign({}, this.meal);
      delete this.editingCache["meals"];
    }
  },
  methods: {
    ...mapMutations(["showNotice"]),
    ...mapActions(["refreshMenus"]),
    createMeal() {
      const menuID = this.menuIdFromName(this.selected).id;
      api.newMeal({ ...this.editingCache, menuId: menuID }).then(() => {
        this.refreshMenus();
        this.showNotice({ newMessage: "Refeiçao criada", type: "success" });
      });
    },
    updateMeal(id) {
      api.updateMeal({ id: id }, this.editingCache).then(() => {
        this.refreshMenus();
        this.showNotice({ newMessage: "Refeiçao atualizada", type: "success" });
      });
    }
  }
};
</script>

<style lang='css'>
#new-menu label {
  text-align: left;
}
.errors-list {
  color: red;
  list-style-type: none;
}
</style